
import { version } from "../../package.json";
import { BUILD_ID } from "../buildInfo";
import { mapGetters, mapMutations } from "vuex";
import StatusConexao from "./StatusConexao.vue";
import Notificacoes from "./Notificacoes";

export default {
  data() {
    return {
      sidebar: false,
      user: "usuario",
      isNavbarActive: false,
      drawer: true,
      selectedItem: 1,
    };
  },

  components: {
    StatusConexao,
    Notificacoes,
  },

  computed: {
    ...mapGetters("usuario", { usuario: "getUsuario" }),
    ...mapGetters("navigation", { navigation: "getNavigationItems" }),

    version() {
      return version;
    },

    buildId() {
      return BUILD_ID;
    },

    nome() {
      if (this.nome) {
        const nome = this.usuario.nome
          .toLowerCase()
          .split(" ")
          .map((i) =>
            i.length <= 3 ? i : i.charAt(0).toUpperCase() + i.slice(1)
          )
          .join(" ");
        return nome;
      } else {
        return {};
      }
    },
  },

  methods: {
    ...mapMutations("navigation", ["setNavigationItems"]),

    go(path) {
      this.$router.push({ path });
    },

    async getNavigation() {
      const userId = this.usuario && this.usuario.id ? this.usuario.id : "";
      if (!userId) return;

      const candidates = [
        `/usuarios/navegacao/${userId}`, // tenta no host/base atual ($http)
        `https://admin.flexcard.info/usuarios/navegacao/${userId}`, // fallback
      ];

      for (const url of candidates) {
        try {
          const res = await this.$http.get(url);
          if (res && res.data) {
            this.setNavigationItems(res.data);
            return;
          }
        } catch (e) {
          const status = e && e.response && e.response.status;
          // ignora 404 e tenta próximo; para outros erros, apenas loga e segue
          if (status !== 404) {
            // mantém um log discreto para depuração
            console.debug(
              "Falha ao carregar navegação:",
              url,
              status || e.message
            );
          }
          // tenta o próximo candidate
        }
      }
      // Se nenhum funcionou, deixa a navegação vazia sem quebrar a UI
      this.setNavigationItems([]);
    },
  },

  async mounted() {
    try {
      await this.getNavigation();
    } catch (_) {
      // não propaga erro para não poluir o console do usuário
    }
  },
};
